module.exports = __webpack_public_path__ + "static/media/021-cloudy-1.0c201000.svg";